import { Contest, ContestGroup } from 'interfaces/leaderboard/contest';

/**
 * Gets the contest-group relationship data for a specific group
 */
export const getContestGroupData = (
  contest: Contest,
  groupId: string
): ContestGroup | undefined => {
  return contest.contest_groups?.find(cg => cg.group_id === groupId);
};

/**
 * Gets the entry fee for a contest in the context of a specific group
 */
export const getContestEntryFee = (
  contest: Contest,
  groupId: string
): number => {
  if (!contest.contest_groups || contest.contest_groups.length === 0) {
    console.warn(`Contest ${contest.id} has no contest_groups array`, contest);
    return 0;
  }

  const contestGroup = getContestGroupData(contest, groupId);
  if (!contestGroup) {
    console.warn(`Contest ${contest.id} not found in group ${groupId}. Available groups:`,
      contest.contest_groups.map(cg => cg.group_id));
    return 0;
  }
  return contestGroup.entry_fee;
};

/**
 * Checks if a contest belongs to a specific group
 */
export const isContestInGroup = (
  contest: Contest,
  groupId: string
): boolean => {
  return contest.contest_groups?.some(cg => cg.group_id === groupId) ?? false;
};

/**
 * Builds a contest page URL with group context
 * This preserves the group when sharing contest links
 */
export const getContestPagePath = (contestId: string, groupId?: string): string => {
  if (groupId) {
    return `/contest/${contestId}?group_id=${groupId}`;
  }
  return `/contest/${contestId}`;
};
